import {
  GetExternalCollaborationPasswordRequest,
  GetExternalCollaborationPasswordRequestToJSON,
  HTTPBody,
  HTTPQuery,
  IssueExternalCollaborationRequest,
  IssueExternalCollaborationRequestToJSON,
  ResetExternalCollaborationRequest,
  ResetExternalCollaborationRequestToJSON
} from '@/api'
import * as runtime from '../runtime'

export class ExternalCollaborationApi extends runtime.BaseAPI {
  async getExternalPassword(
    request: GetExternalCollaborationPasswordRequest
  ): Promise<string> {
    const queryParameters: HTTPQuery = Object.fromEntries(
      Object.entries(
        GetExternalCollaborationPasswordRequestToJSON(request)
      ).filter(value => value[1] !== undefined)
    ) as HTTPQuery

    const response = await this.requestGet(
      '/external-collaborations/password',
      queryParameters
    )

    return new runtime.JSONApiResponse(
      response,
      jsonValue => jsonValue.password
    ).value()
  }

  async issueExternalCollaboration(
    request: IssueExternalCollaborationRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: HTTPBody = IssueExternalCollaborationRequestToJSON(
      request
    )

    const response = await this.requestPost(
      '/external-collaborations/issue',
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  async resetExternalCollaboration(
    request: ResetExternalCollaborationRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: HTTPBody = ResetExternalCollaborationRequestToJSON(
      request
    )

    const response = await this.requestPost(
      '/external-collaborations/reset',
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }
}
